import { render } from "./d-login.vue?vue&type=template&id=545b8015&scoped=true&ts=true"
import script from "./d-login.vue?vue&type=script&lang=ts"
export * from "./d-login.vue?vue&type=script&lang=ts"

import "./d-login.vue?vue&type=style&index=0&id=545b8015&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newb\\bnet2.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-545b8015"]])

export default __exports__